import { getInstanceElement, currentContext, extractFromPath } from "../binding";

const COMPONENT_NAME = "z-script" ;

export default function register(){
    let scriptInc = 0 ;
    class ScriptComponent extends HTMLElement {
        constructor() {
            super();
        }

        connectedCallback(){
            const isBindPrepared = this.closest('[zz-bind-prepared="true"]') ||
                                        this.closest("[zz-instance-el]") ;
            if(!isBindPrepared){
                //binding is not yet initialized, don't create the script
                //to avoid to be run to soon
                return;
            }
            let scriptTag = this.querySelector("script") ;
            
            let script = scriptTag?scriptTag.innerHTML:this.innerHTML.replace(/&gt;/g, ">");
            this.innerHTML = "" ;
            scriptTag = document.createElement("script") ;

            const instanceEl = getInstanceElement(this) ;
            const context = currentContext(this) ; 
            const scriptContext = {
                document: instanceEl,
                context: context,
                getData: instanceEl.getData, 
                getRootData: instanceEl.getRootData, 
                getBindData : ()=>{
                    const zBind = script.getAttribute("z-bind") ;
                    if(zBind[0] === "{"){
                        const bindSettings = JSON.parse(zBind) ;
                        if(bindSettings._value){
                            let rData = instanceEl.getRootData() ;
                            return extractFromPath(rData, bindSettings._value) ;
                        } 
                    }
                    return instanceEl.getData() ;
                }
            } ;

            // scriptInc++;
            // window["__zscript_context_"+scriptInc] = scriptContext;

            // const w = `window["__zscript_context_${scriptInc}"]` ;

            // //document, getData, getRootData, getBindData
            // script = `(function(document, getData, getRootData, getBindData, context){
            //     ${script}
            // })(${w}.document, ${w}.getData, ${w}.getRootData, ${w}.getBindData, ${w}.context)` ;
            // scriptTag.innerHTML = script ;
            // this.appendChild(scriptTag) ;

            const scriptFunction = new Function("document", "getData", "getRootData", "getBindData", "context", script) ;
            scriptFunction.call(null,scriptContext.document, scriptContext.getData, scriptContext.getRootData, scriptContext.getBindData, scriptContext.context ) ;
        }
    }
    customElements.define(COMPONENT_NAME, ScriptComponent);

}
